import chalk from 'chalk';
import { CONFIGS } from './configs';
import { getKey } from './utils/keys';
import { refreshToken } from "./commands";

export const wrapper = async (cmd: string, callback: CallableFunction) => {

  if (!["upgrade", "login", "build", "logout"].includes(cmd)) {
    await refreshToken();
  }

  if (!["upgrade", "login", "init", "build", "logout"].includes(cmd) && !getKey(`${CONFIGS.PROJECT_DIR}`)) {
    console.error(chalk.red(`Application not configured. Please run '${chalk.italic("superpush init")}' to configure.\n`));
    process.exit(1);
  }

  await Promise.resolve(callback());
};